export default __webpack_public_path__ + "static/5-3345d37cf08a84212d8971c77c6f8080.webp";